<template>
  <div class="warehouse-info">
    <el-tabs v-model="warehouseTabs" class="client-tabs" >
      <el-tab-pane label="香港仓" name="hk">
        <el-row :gutter="20" class="info">
          <el-col :span="12">
            <div class="company">
              <div class="hd">
                <div class="left">
                  <div class="name">
                    錦盛（香港）有限公司 
                    <em>Future Promising Company Limited</em>
                  </div>
                  <div v-if="warehouseNumber" class="number" @click="copyNumber()">
                    入仓号&nbsp;|<b>{{ warehouseNumber }}</b>
                  </div>
                </div>
                <div class="right">
                  <div
                    class="copy"
                    @click="copyInfo('hk')"
                  >
                    <ab-svg name="copy"></ab-svg>
                    复制
                  </div>
                  <el-button
                    type="primary"
                    :loading="dlLoading"
                    @click="downloadFile('hk')"
                  >下载</el-button>
                </div>
              </div>
              <div class="address">
                地址：香港沙田安平街 8 号偉達中心 8 楼 801 室
                <em>Units 801, Grandtech Centre, No.8 OnPing Street, Siu Lek Yuen, Shatin, NewTerritories, Hong Kong</em>
              </div>
              <div class="row">邮　箱：luo.zhanwei@cicsc.com</div>
              <div class="row">联系人：羅占偉</div>
              <div class="row">電　話：00852-26089369</div>
              <div class="row">传　真：00852-26089331</div>
            </div>
          </el-col>

          <el-col :span="12">
            <div class="delivery">
              <div class="table">
                <el-row class="hd">
                  <el-col :span="12">收貨、發貨時間</el-col>
                  <el-col :span="6">上午</el-col>
                  <el-col :span="6">下午</el-col>
                </el-row>
                <el-row class="row">
                  <el-col :span="12">星期一至星期五</el-col>
                  <el-col :span="6">9:00-12:30</el-col>
                  <el-col :span="6">14:00-18:00</el-col>
                </el-row>
                <el-row class="row">
                  <el-col :span="12">星期六</el-col>
                  <el-col :span="6">9:00-12:00</el-col>
                  <el-col :span="6">/</el-col>
                </el-row>
              </div>
              <div class="flow">
                <div class="tit">交仓流程：</div>
                <div class="list">
                  <div class="item">登记</div>
                  <div class="arrow"></div>
                  <div class="item">过磅称重</div>
                  <div class="arrow"></div>
                  <div class="item">外观检查</div>
                  <div class="arrow"></div>
                  <div class="item">数量清点</div>
                  <div class="arrow"></div>
                  <div class="item">货物签收</div>
                  <div class="arrow"></div>
                  <div class="item">单据交接</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>

      <el-tab-pane label="国内仓" name="cn">
        <el-row :gutter="20" class="info">
          <el-col :span="12">
            <div class="company">
              <div class="hd">
                <div class="left">
                  <div class="name">
                    深圳市一咻科技有限公司
                    <em>Shenzhen Z-easy Technology Co.,Ltd</em>
                  </div>
                </div>
                <div class="right">
                  <div
                    class="copy"
                    @click="copyInfo('cn')"
                  >
                    <ab-svg name="copy"></ab-svg>
                    复制
                  </div>
                  <el-button
                    type="primary"
                    :loading="dlLoading"
                    @click="downloadFile('cn')"
                  >下载</el-button>
                </div>
              </div>
              <div class="address">
                地址：东莞市凤岗镇京东智谷10栋701-702
                <em>701-702, 10th Building,Jingdong Zhigu, Fenggang Town, Dongguan</em>
              </div>
              <div class="row">邮　箱：chen.gang@cicsc.com，cheng.zhengbai@cicsc.com</div>
              <div class="row">联系人：陈刚，程正柏</div>
              <div class="row">电　话：18503021572（陈）</div>
              <div class="row">电　话：18823090447（程）</div>
            </div>
          </el-col>

          <el-col :span="12">
            <div class="delivery">
              <div class="table">
                <el-row class="hd">
                  <el-col :span="12">收货、发货时间</el-col>
                  <el-col :span="6">上午</el-col>
                  <el-col :span="6">下午</el-col>
                </el-row>
                <el-row class="row">
                  <el-col :span="12">星期一至星期五</el-col>
                  <el-col :span="6">8:30-12:00</el-col>
                  <el-col :span="6">13:30-18:00</el-col>
                </el-row>
                <el-row class="row">
                  <el-col :span="12">周末及法定假期</el-col>
                  <el-col :span="12">(若在非工作时间送货，请提前与商务联系)</el-col>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <div class="map-ZN" v-if="warehouseTabs == 'hk'">
        <img src="../../assets/img/map-HK.png" alt="">
    </div>
    <div class="map-HK" v-else>
        <img src="../../assets/img/map-ZN.png" alt="">
    </div>

    <textarea class="copy-text" id="copyText"></textarea>
  </div>
</template>

<script>
export default {
  name: 'warehouse-info',
  components: {

  },

  data() {
    return {
      warehouseTabs: 'hk',
      warehouseNumber: '',
      dlLoading: false
    }
  },

  computed: {

  },

  watch: {
    warehouseTabs(value) {
      
    }
  },

  created() {
    this.getWarehouseNumber()
  },

  methods: {
    // 入仓号
    getWarehouseNumber() {
      this.$post('/bas/client/basCustomer/getClientWorkBench').then(({ data }) => {
        if (data.code === 'C0000' && data.result) {
          this.warehouseNumber = data.result.principal.number
        }
      })
    },

    // 复制入仓号
    copyNumber() {
      const input = document.getElementById('copyText')  // 找到虚拟的输入框
      input.value = this.warehouseNumber // 修改文本框的内容
      input.select() // 选中文本
      document.execCommand('copy') // 执行浏览器复制命令
      this.$message({
        type: 'success',
        message: '复制成功!',
        offset: 380,
        grouping: true
      })
    },

    // 复制文本
    copyInfo(tab) {
      let infoText = ''
      if (tab === 'hk') {
        infoText = '錦盛（香港）有限公司\n' +
        'Future Promising Company Limited\n' +
        '地址：香港沙田安平街 8 号偉達中心 8 楼 801 室\n' +
        'Units 801, Grandtech Centre, No.8 OnPing Street, Siu Lek Yuen, Shatin, NewTerritories, Hong Kong\n' +
        '邮箱：luo.zhanwei@cicsc.com\n' +
        '联系人：羅占偉\n' +
        '電話：00852-26089369\n' +
        '传真：00852-26089331\n' +
        '入仓号：' + this.warehouseNumber
      } else if (tab === 'cn') {
        infoText = '深圳市一咻科技有限公司\n' +
        'Shenzhen Z-easy Technology Co.,Ltd\n' +
        '地址：东莞市凤岗镇京东智谷10栋701-702\n' +
        '701-702, 10th Building,Jingdong Zhigu, Fenggang Town, Dongguan\n' +
        '邮箱：chen.gang@cicsc.com，cheng.zhengbai@cicsc.com\n' +
        '联系人：陈刚，程正柏\n' +
        '电话：18503021572（陈）\n' +
        '电话：18823090447（程）'
      }
      const input = document.getElementById('copyText')  // 找到虚拟的输入框
      input.value = infoText // 修改文本框的内容
      input.select() // 选中文本
      document.execCommand('copy') // 执行浏览器复制命令
      this.$message({
        type: 'success',
        message: '复制成功!',
        offset: 380,
        grouping: true
      })
    },
    
    // 下载
    downloadFile(tab) {
      this.dlLoading = true
      if (tab === 'hk') {
        this.$get(`/tms/client/accessionNumber/getAccessionPdf?number=${this.warehouseNumber}`).then(({ data }) => {
          if(data.code === 'C0000' && data.message) {
            window.open(data.message)
          }
        }).finally(() => {
          this.dlLoading = false
        })
      } else if (tab === 'cn') {
        const domA = document.createElement('a')
        fetch('https://scp-static.oss-cn-shenzhen.aliyuncs.com/receiptInfo/收货指引-东莞凤岗仓.pdf').then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
          domA.href = URL.createObjectURL(blob)
          domA.download = '收货指引-东莞凤岗仓' // 下载文件的名字
          document.body.appendChild(domA)
          domA.click()
        }).finally(() => {
          this.dlLoading = false
        })
      }
    },
  }
}
</script>

<style lang="scss">
.warehouse-info {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 35px 40px 40px;
  font-size: 14px;
  text-align: left;
  .el-tabs .el-tabs__header {
    margin-bottom: 26px;
  }
  .info > .el-col {
    padding-bottom: 20px;
  }
  .company, .delivery {
    min-height: 306px;
    background: linear-gradient(270deg, #C9DFF9, #F8F8F8);
    box-shadow: 0px 3px 68px 0px rgba(0, 0, 0, 0.05);
    border-radius: 16px;
  }
  .company {
    padding: 25px;
    .hd {
      display: flex;
      justify-content: space-between;
      .right {
        width: 174px;
        flex: none;
      }
      .name {
        display: inline-block;
        margin-right: 16px;
        font-size: 22px;
        line-height: 26px;
        color: #000;
        em {
          display: block;
          font-size: 12px;
          color: #737373;
        }
      }
      .number {
        display: inline-block;
        height: 36px;
        padding: 0 15px;
        font-size: 16px;
        line-height: 36px;
        vertical-align: top;
        color: #f00;
        border-top-left-radius: 15px;
        border-bottom-right-radius: 15px;
        background: #e4bbc7;
        cursor: pointer;
        b {
          margin-left: 4px;
          font-size: 18px;
        }
      }
      .copy {
        display: inline-block;
        margin-right: 30px;
        vertical-align: middle;
        cursor: pointer;
        .icon-svg {
          width: 16px;
          height: 16px;
          margin-top: 1px;
          vertical-align: text-top;
        }
      }
    }
    .address {
      margin: 10px 0 6px;
      line-height: 20px;
      color: #000;
      em {
        display: block;
        font-size: 12px;
        color: #737373;
      }
    }
    .row {
      line-height: 37px;
      color: #000;
    }
  }
  .delivery {
    padding: 30px;
    .table {
      .el-row {
        border-radius: 8px;
        margin-bottom: 1px;
        .el-col {
          padding: 15px 0;
          line-height: 20px;
          &:first-child {
            padding-left: 35px;
          }
        }
      }
      .hd {
        background: #DEEAF9;
      }
      .row {
        background: #fff;
      }
    }
    .flow {
      display: flex;
      margin-top: 30px;
      .tit {
        width: 70px;
        line-height: 60px;
        flex: none;
      }
      .list {
        flex-wrap: wrap;
        display: flex;
        .item {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 60px;
          height: 60px;
          padding: 0 15px;
          line-height: 15px;
          border-radius: 50%;
          background: #fff;
        }
        .arrow {
          position: relative;
          width: 13px;
          margin: 0 8px 0 14px;
          &::after {
            position: absolute;
            top: 22px;
            content: '';
            width: 0;
            height: 0;
            border-left: 13px solid #fff;
            border-top: 8px solid transparent;
            border-bottom: 8px solid transparent;
          }
        }
      }
    }
  }
  .map-ZN, .map-HK{
    img{
        width: 100%;
    }
  }
  .baidu-map {
    width: 100%;
    height: 306px;
    border-radius: 16px;
    .map-label-icon {
      display: inline-block;
      width: 36px;
      height: 36px;
      margin-right: 9px;
      border-radius: 50%;
      vertical-align: top;
      background: #fff url(@/assets/img/map-location.svg) no-repeat center;
    }
  }
}
</style>